import { Col, Divider, Row, Spin, Tabs } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getOwnInvoicesByStatus } from "../../../lib/getOwnInvoicesByStatus";
import ModalComprobantePago from "../invoices/ModalComprobantePago";
import ModalPreviewPDF from "./ModalPreviewPDF";

const OwnInvoiceManagement = () => {
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [acceptedInvoices, setAcceptedInvoices] = useState([]);
  const [canceledInvoices, setCanceledInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState();
  const [showPreviewPDF, setShowPreviewPDF] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  
  const [loading, setLoading] = useState(true);
  const storage = JSON.parse(window.localStorage.getItem("userDetails"));
  const serverHost = `http://${window.location.hostname.includes('localhost') ? 'localhost:4000' : 'unioninformatica.org:4000'}`;

  const calcularTotal = (data) => {
    const total = Object.values(data).reduce(
      (accumulator, employee) =>
        accumulator +
        employee.reduce(
          (empAccumulator, emp) => empAccumulator + emp.calculatedSalary,
          0
        ),
      0
    );

    return Number(total).toLocaleString("de-DE", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };
  const getFacturas = async () => {
    try {
      setLoading(true);
      const res = await getOwnInvoicesByStatus(storage.companyProfile?._id);

      setPendingInvoices(
        res.data[0].invoices.filter((x) => x.status === "PENDING")
      );
      setAcceptedInvoices(
        res.data[0].invoices.filter((x) => x.status === "ACCEPTED")
      );
      setCanceledInvoices(
        res.data[0].invoices.filter((x) => x.status === "CANCELED")
      );
    } catch (error) {
      console.error("Error al obtener facturas", error);
    } finally {
      setLoading(false);
    }
  }; 
   useEffect(() => {
    getFacturas();
  }, [storage.companyProfile?._id]);

  const Pendientes = () => {
    return (
      <>
        {pendingInvoices.length > 0 &&
          pendingInvoices.map((invoice, index) => {
            if (invoice.status === "PENDING") {
              return (
                <>
                  <Row
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                      <p style={{ fontWeight: "bold" }} key={index}>
                        Factura Nº: {invoice.invoiceNumber} 
                      </p>
                      <p style={{ fontWeight: "bold" }} >
                        Tipo Factura: {(invoice?.tipoFactura && invoice?.tipoFactura ==="formacion") ? 'Por Formacion': 'Sindical'} 
                      </p>
                      <p>
                        <strong>Período : </strong>
                        {moment(invoice.period[0]).format("DD/MM/YYYY")} -{" "}
                        {moment(invoice.period[1]).format("DD/MM/YYYY")}
                      </p>
                    </Col>
                    <Col xs={20} sm={16} md={12} lg={8} xl={8}></Col>
                  </Row>
                  <Divider style={{ backgroundColor: "#e6e6e6" }} />
                </>
              );
            }
          })}
      </>
    );
  };

  const Aceptadas = () => {
    return (
      <>
        {acceptedInvoices.length > 0 &&
          acceptedInvoices.map((invoice, index) => {
            if (invoice.status === "ACCEPTED") {
              return (
                <>
                  <Row
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                      <p style={{ fontWeight: "bold" }} key={index}>
                        Factura Nº: {invoice.invoiceNumber}
                      </p>
                      <p style={{ fontWeight: "bold" }}>
                      Tipo Factura: {(invoice?.tipoFactura && invoice?.tipoFactura ==="formacion") ? 'Por Formacion': 'Sindical'} 
                      </p>
                      <p>
                        <strong>Período : </strong>
                        {moment(invoice.period[0]).format("DD/MM/YYYY")} -{" "}
                        {moment(invoice.period[1]).format("DD/MM/YYYY")}
                      </p>
                      <p>
                        <strong>
                          Importe total : $ {calcularTotal(invoice.detail)}
                        </strong>
                      </p>
                    </Col>
                    <Col xs={20} sm={16} md={12} lg={8} xl={8}></Col>

                    <Link
                      to={"#"}
                      onClick={() => {
                        debugger;
                        setSelectedInvoice(invoice);
                        setShowPreviewPDF(true);
                      }}
                      className="btn btn-warning shadow btn-xs sharp me-3"
                    >
                      <i className="fas fa-eye"></i>
                    </Link>
                    {!invoice.comprobantePath ? (
                        <Link
                          to={"#"}
                          onClick={() => {
                            setSelectedInvoice(invoice);
                            setShowUploadModal(true);
                          }}
                          title="Cargar Comprobante"
                          className="btn btn-warning shadow btn-xs sharp me-3"
                        >
                          <i className="fas fa-file"></i>
                        </Link>
                      ) : (
                        <Link
                          to={`${serverHost}${invoice.comprobantePath}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-success shadow btn-xs sharp me-3"
                          title="Ver comprobante"
                        >
                          <i className="fas fa-paperclip"></i>
                        </Link>
                      )}

                    
                  </Row>
                  <Divider style={{ backgroundColor: "#e6e6e6" }} />
                </>
              );
            }
          })}
      </>
    );
  };

  const Canceladas = () => {
    return (
      <>
        {canceledInvoices.length > 0 &&
          canceledInvoices.map((invoice, index) => {
            if (invoice.status === "CANCELED") {
              return (
                <>
                  <Row
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                      <p style={{ fontWeight: "bold" }} key={index}>
                        Factura Nº: {invoice.invoiceNumber}
                      </p>
                      <p style={{ fontWeight: "bold" }} >
                      Tipo Factura: {(invoice?.tipoFactura && invoice?.tipoFactura ==="formacion") ? 'Por Formacion': 'Sindical'} 
                      </p>
                      <p>
                        <strong>Período : </strong>
                        {moment(invoice.period[0]).format("DD/MM/YYYY")} -{" "}
                        {moment(invoice.period[1]).format("DD/MM/YYYY")}
                      </p>
                    </Col>
                    <Col xs={20} sm={16} md={12} lg={8} xl={8}>
                      <strong>Motivo:</strong> {invoice.motive}
                    </Col>
                  </Row>
                  <Divider style={{ backgroundColor: "#e6e6e6" }} />
                </>
              );
            }
          })}
      </>
    );
  };
  const items = [
    {
      key: "1",
      label: `PENDIENTES (${pendingInvoices.length})`,
      children: <Pendientes />,
    },
    {
      key: "2",
      label: `ACEPTADAS (${acceptedInvoices.length})`,
      children: <Aceptadas />,
    },
    {
      key: "3",
      label: `CANCELADAS (${canceledInvoices.length})`,
      children: <Canceladas />,
    },
  ];

  return (
    <>
      <h3 className="">Panel de facturación</h3>
      <div style={{ maxHeight: "900px", overflow: "auto" }}>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <Tabs defaultActiveKey="1" items={items} />
        )}
      </div>
      {showPreviewPDF && (
        <ModalPreviewPDF
          showOpen={showPreviewPDF}
          setShowOpen={setShowPreviewPDF}
          selectedInvoice={selectedInvoice}
        />
      )}
   {showUploadModal && (
      <ModalComprobantePago
        show={showUploadModal}
        setShow={setShowUploadModal}
        selectedInvoice={selectedInvoice}
        onSuccess={getFacturas}
      />)}
    </>
  );
};

export default OwnInvoiceManagement;
